
//the function assumes that path starts with 'partials/' and ends with '.html'
function getPartial(path) {
    const partialMap = require("../../../assets/partials").default;
    const pathWithoutExtension = path.slice(0, -5);
    if(!partialMap.has(pathWithoutExtension)) { return null; }//or throw an exception, not sure
    return partialMap.get(pathWithoutExtension);
}

export default getPartial;